import type { WalletMonitoringItem } from '@shared/api/contracts';

export const filterOperationWallets = (
  wallets: WalletMonitoringItem[],
  query: string,
): WalletMonitoringItem[] => {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return wallets;

  return wallets.filter((wallet) => {
    const name = (wallet.name || '').toLowerCase();
    const id = String(wallet.id).toLowerCase();
    const group = `${wallet.group?.name ?? ''} ${wallet.group?.code ?? ''}`.toLowerCase();
    return name.includes(normalized) || id.includes(normalized) || group.includes(normalized);
  });
};

export const formatOperationWalletLabel = (wallet: WalletMonitoringItem): string => {
  const name = wallet.name || String(wallet.id);
  if (wallet.group?.name && wallet.group.code === 'merchants') {
    return `${name} · ${wallet.group.name}`;
  }
  return name;
};
